import moment from 'moment';
import {dateStringSort} from '../../../../utils/sort';


export default function updateData(rawDataCollection, rows) {

  const invalidRows = getInvalidRows(rows, rawDataCollection);

  if (invalidRows.length > 0) {
    rows = invalidRows;
  } else {
    rows = updateRows(rows, rawDataCollection);
  }

  let newRxHistory = [];
  for (let row of rows) {
    newRxHistory.push({
      ptAlias: row.ptAlias,
      startDate: row.startDate,
      stopDate: row.stopDate,
      durationUnknown: row.durationUnknown || 'Yes',
      orderUnknown: row.orderUnknown || 'No',
      drugs: row.drugs || '',
    });
  }
  rawDataCollection.rawRxHistory = newRxHistory;
  return rawDataCollection;
}

function getInvalidRows(rows, rawDataCollection) {
  const {ptAliasIsolateDateMap} = rawDataCollection;

  let invalidRows = [];

  for (const row of rows) {
    const {ptAlias, drugs} = row;
    if (!ptAlias || !drugs) {
      invalidRows.push(row);
      continue;
    }
    const isolateDates = ptAliasIsolateDateMap[ptAlias];

    if (!isolateDates) {
      invalidRows.push(row);
    }
  }

  return invalidRows;
}

function updateRows(rows, rawDataCollection)  {

  const patientRows = groupRowsByPatient(rows);
  const {ptAliasIsolateDateMap} = rawDataCollection;

  let newRows = [];

  for (const ptAlias of Object.keys(patientRows)) {
    let ptRxList = patientRows[ptAlias];

    const isolateDates = ptAliasIsolateDateMap[ptAlias];

    newRows = newRows.concat(
      buildNewRxList(ptRxList, isolateDates)
    );

  }

  return newRows;
}

function groupRowsByPatient(rows) {
  let patientRows = {};

  for (const row of rows) {
    const ptAlias = row.ptAlias;
    patientRows[ptAlias] = patientRows[ptAlias] || [];
    patientRows[ptAlias].push(row);
  }

  return patientRows;
}


function buildNewRxList(ptRxList, isolateDates) {
  if (isolateDates.length === 1) {
    return buildByOneSequence(ptRxList, isolateDates);
  } else {
    return buildByMultiSequence(ptRxList, isolateDates);
  }
}

function buildByOneSequence(ptRxList, isolateDates) {
  let newRxList = [];

  const isolateDate = isolateDates[0];
  let nextStartDate = null;
  for (const ptRx of ptRxList.reverse()) {
    let {ptAlias, weeks, drugs, startDate, stopDate, durationUnknown} = ptRx;

    // User should provide this column
    // if (startDate && stopDate) {
    //   durationUnknown = 'No'
    // }

    if (!stopDate) {
      stopDate = nextStartDate || isolateDate;
    }

    if (!startDate) {
      startDate = getWeeksBefore(stopDate, weeks || 52);
    }

    newRxList.push({
      ptAlias: ptAlias,
      startDate: startDate,
      stopDate: stopDate,
      drugs: drugs || '',
      durationUnknown: durationUnknown || 'Yes',
      orderUnknown: getOrderUnknown(ptRx),
    });

    nextStartDate = startDate;
  }

  newRxList = mergeRxWithSameDrugs(newRxList);

  return newRxList;
}

function buildByMultiSequence(ptRxList, isolateDates) {
  let newRxList = [];

  let nextStartDate = null;
  for (const [idx, ptRx] of ptRxList.reverse().entries()) {
    const isolateDate = isolateDates.reverse()[idx];
    // const previousIsolateDate = isolateDates.reverse[idx+1];
    let {
      ptAlias, startDate, stopDate, drugs,
      durationUnknown, weeks} = ptRx;

    // if (startDate && stopDate) {
    //   durationUnknown = 'No'
    // }

    if (!stopDate) {
      stopDate = nextStartDate || isolateDate;
    }

    if (!startDate) {
      startDate = getWeeksBefore(stopDate, weeks || 52);
    }

    newRxList.push({
      ptAlias: ptAlias,
      startDate: startDate || null,
      stopDate: stopDate || null,
      drugs: drugs || 'Unknown',
      durationUnknown: durationUnknown || 'Yes',
      orderUnknown: getOrderUnknown(ptRx),
    });

    nextStartDate = startDate;
  }

  newRxList = mergeRxWithSameDrugs(newRxList);

  return newRxList;
}

function getOrderUnknown(record) {
  const {drugs} = record;
  if (drugs && drugs.includes(',')) {
    return 'Yes';
  } else {
    return 'No';
  }
}

function getWeeksBefore(stopDate, weeks) {
  stopDate = moment.utc(stopDate);
  weeks = parseInt(weeks);
  if (!weeks || weeks === 52) {
    return stopDate.subtract(1, 'years').format('YYYY-MM-DD');
  } else {
    return stopDate.subtract(weeks, 'weeks').format('YYYY-MM-DD');
  }
}

// function getWeeksAfter(startDate, weeks) {
//   startDate = moment.utc(startDate);
//   weeks = parseInt(weeks);
//   if (!weeks || weeks === 52) {
//     return startDate.add(1, 'years').format('YYYY-MM-DD');
//   } else {
//     return startDate.add(weeks, 'weeks').format('YYYY-MM-DD');
//   }
// }

function mergeRxWithSameDrugs(newRxList) {
  newRxList = newRxList.sort((rx1, rx2) => {
    return dateStringSort(rx1.startDate, rx2.startDate);
  });

  newRxList = newRxList.reduce((acc, rx) => {
    const prevRx = acc.length > 0? acc.slice(-1)[0]: null;
    if (!prevRx) {
      acc.push(rx);
    } else if (prevRx.drugs === rx.drugs) {
      prevRx.stopDate = rx.stopDate;
      if (prevRx.durationUnknown === 'Yes' || rx.durationUnknown === 'Yes') {
        prevRx.durationUnknown = 'Yes';
      }
    } else {
      acc.push(rx);
    }
    return acc;
  }, []);

  return newRxList;
}



// WEBPACK FOOTER //
// ./src/views/wizard/rx-list/gtable/update-data.js